import { getTargetFootprint } from "./Finalsize";

function getConfidence(lengthDiff, widthDiff) {
  const combined = lengthDiff * 0.7 + widthDiff * 0.3;

  if (combined <= 0.25) return "High";
  if (combined <= 0.5) return "Medium";
  return "Low";
}

export function getRecommendedSize(measurements, sizes) {
  if (
    !measurements ||
    !Array.isArray(sizes) ||
    sizes.length === 0
  ) {
    return null;
  }

  const footprint = getTargetFootprint(measurements);
  if (!footprint) return null;

  const { targetLength, targetWidth } = footprint;

  const Toe_allowance = 0.5;
  const minLength = Math.min(...sizes.map(s => s.length));
  const maxLength = Math.max(...sizes.map(s => s.length));
    if (targetLength > maxLength) {
      return {
        bestFit: null,
        confidence: null,
        message: "Size not available",
      };
    }

    // Too small for the smallest available shoe
    if (targetLength < minLength - Toe_allowance) {
      return {
        bestFit: null,
        confidence: null,
        message: "Size not available",
      };
    }


  // 1️⃣ Remove sizes that are too short (toe space violated)
  const validSizes = sizes.filter(
    (s) =>
      s.length >= targetLength - 0.2 && // allow slight size-down
      s.length <= targetLength + 1
  );

  if (validSizes.length === 0) {
    return {
      bestFit: null,
      confidence: "Low",
      message: "We recommend sizing up for comfort."
    };
  }

  // 2️⃣ Sort by closest length ABOVE target (prefer size-up)
  validSizes.sort((a, b) => {
    const lengthA = a.length - targetLength;
    const lengthB = b.length - targetLength;

    // Prefer smallest positive gap
    if (lengthA !== lengthB) return lengthA - lengthB;

    // Tie-breaker: width closeness
    const widthA = Math.abs((a.width ?? targetWidth) - targetWidth);
    const widthB = Math.abs((b.width ?? targetWidth) - targetWidth);
    return widthA - widthB;
  });

  const best = validSizes[0];

  const lengthDiff = best.length - targetLength;
  const widthDiff = Math.abs((best.width ?? targetWidth) - targetWidth);

  return {
    bestFit: best.size,
    confidence: getConfidence(lengthDiff, widthDiff)
  };
}
